import React from 'react';
import * as api from '../../api/facility'
import { deleteProject } from '../../api/projects'
import PageList from '../../components/PageListAPI'
import FacilityByIdHeader from './source/FacilityByIdHeader'
import Button from '@mui/material/Button'
import { Link } from 'react-router-dom';
import { API_BO } from '../../conf'
import { useDispatch } from 'react-redux';
import { headerSetProject } from '../../reducers/header'
import { useCan } from '../../hooks/useCan';
import { SLUGS } from '../../enum/permissions.enum';


export default function FacilityById (props) {
  const can = useCan()
  const toLinkEdit = React.forwardRef((propsRef, ref) => (<Link to={props.match.url + '/edit'} {...propsRef} />))
  const dispatch = useDispatch()
  return (
    <div className='App-paper'>
      <PageList
        name='facilityById'
        columns={[
          { id: 'name', name: 'Наименование' },
          { id: 'by', name: 'Заказано материалов' },
          { id: 'costs', name: 'Выработано материалов' },
          { id: 'byWork', name: 'Выполнено работ' },
          { id: 'byAll', name: 'Всего затрат по смете', type: 'price'  },
          { id: 'byFact', name: 'Текущие затраты по плану', type: 'price'  },
          { id: 'byPlan', name: 'Текущие затраты по факту', type: 'price'  },
        ]}
        idName='id'
        headerInit={{
          obj: {
            description: '',
            name: ''
          }
        }}
        loadAPI={{
          param: {
            id: props.match.params.id
          },
          request: api.getFacilityProject,
        }}
        csv={false}
        click={false}
        pagination={false}
        headerObj={<FacilityByIdHeader idFacility={props.match.params.id} />}
        headerLink={can(SLUGS.FACILITY.UPDATE)&&
          <React.Fragment>
            <Button  component={toLinkEdit} color="primary" >Изменить </Button>
          </React.Fragment>
        }
        onClickFunction={(row, obj) => {
          props.history.push(`${API_BO}/projects/${obj.id}`)
          dispatch(headerSetProject({ id: obj.id, name: obj.name }))
        }}
        createItem={can(SLUGS.PROJECT.ROOT.CREATE)}
        deleteItem={can(SLUGS.PROJECT.ROOT.DELETE)}
        deleteAPI={deleteProject}
        tableProps={{
          pagination: false
        }}
        goBack={false}
        {...props}
      />
      <Button color='primary' component="span" onClick={() => props.history.goBack()}>Назад</Button>
    </div>
  )
}
